// @ts-nocheck
import { $t, i18n } from '@/locales'
import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import { $CMSAxios, $Http, $EHttp } from './lib/http/index'
import { isClient } from '@/lib/utils'
import tsignData from './lib/tsignData'
import tool from '@/components/dialog/dialog'
import { Message } from 'element-ui'
import pluginsElement from '@/plugins/element'
const { default: Toast } = require('vant/lib/toast')
require('vant/lib/toast/style')

Vue.prototype.$dialog = {
  confirm: tool.eConfirm,
  alert: tool.Alert,
  toast: tool.eToast,
  notify: tool.Notify,
}

Vue.prototype.$toast = Toast

// 创建DOM，用来发送植入页面的变量
const element = document.createElement('div')
element.id = 'esign_chrome_dashboard'
element.style.display = 'none'
element.onclick = function getEnvariement() {
  window.postMessage({ type: 'WINDOW_ENV', env: process.env }, window.location.href)
}
document.body.appendChild(element)

Vue.use(pluginsElement)

// import Vconsole from 'vconsole'

// const vc = new Vconsole()
// console.info(vc)
Vue.prototype.$ELEMENT = { size: 'small' }

Vue.config.productionTip = false

Vue.prototype.$axios = $CMSAxios
Vue.prototype.$Http = $Http
Vue.prototype.$EHttp = $EHttp
Vue.prototype.$message = Message

Vue.prototype.$isClient = isClient()

Vue.prototype.$tsignData = tsignData
console.info('init tsignData')
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

// 监听全局unhandledrejection
window.onunhandledrejection = () => {}
